import { useMountEffect } from "@/hooks/use-mount-effect";
import React, { useState } from "react";
import { Provider as UrqlProvider } from "urql";

import { getEffectiveGraphqlBaseUrl } from "../graphql-url-override/graphql-url-override";
import { createApiClient } from "../graphql/client";
import { ApiClientContext } from "./ApiClientContext";
import type { ApiClientState } from "./types";

export const ApiProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [ready, setReady] = useState(false);
  const [state, setState] = useState<ApiClientState | null>(null);

  const reinitialize = async () => {
    const url = await getEffectiveGraphqlBaseUrl();
    setState((prev) => ({
      key: (prev?.key ?? 0) + 1,
      client: createApiClient(url || "/graphql"),
    }));
    setReady(true);
  };

  const clearCache = () => {
    void reinitialize();
  };

  useMountEffect(() => {
    void reinitialize();
  });

  if (!ready || !state) {
    return null;
  }

  return (
    <ApiClientContext.Provider value={{ clearCache, reinitialize }}>
      <UrqlProvider key={state.key} value={state.client}>
        {children}
      </UrqlProvider>
    </ApiClientContext.Provider>
  );
};
